import { render } from "./EntitySummaryCard.vue?vue&type=template&id=675d5f78"
import script from "./EntitySummaryCard.vue?vue&type=script&lang=js"
export * from "./EntitySummaryCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__